import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/use-auth";

export function useIsExperimental(): boolean {
  const { user } = useAuth();
  const { data } = useQuery<{ isExperimental: boolean }>({
    queryKey: ["/api/admin/is-experimental"],
    enabled: !!user,
    staleTime: 60_000,
  });
  return data?.isExperimental ?? false;
}
